<template>
    <ListingComponent
        v-bind="listingData"
        :buttons="customButtons"
        :storeModule="storeModule"
        @listinghash="storeRows"
        @verify-all="verifyAll"
    />
</template>
<script>
import ListingComponent from 'vcomponents/listing/Listing.vue';
import LocalStorage from 'Core/commons/LocalStorage';
import { goToUrl } from 'js/vue/helpers';
import OcrListing from 'stores/ocrListing';
import Ocr from 'api/ocr';
import { cloneDeep } from 'lodash';

export default {
    name: 'OcrList',
    components: {
        ListingComponent,
    },
    inheritAttrs: false,
    props: {},
    data() {
        return {
            hash: null,
            ocrLocalStorage: new LocalStorage('ocr', 'form.verification'),
        };
    },
    computed: {
        listingData() {
            return Object.keys(this.$props).length > 0 ? this.$props : this.$route.params;
        },
        rows() {
            return this.hash ? this.$store.state[this.hash].rows : [];
        },
        storeModule() {
            return OcrListing;
        },
        canValidatePurInvoice() {
            return this.hash
                ? this.$store.state[this.hash].metadatas.user_can_validate_pur_invoice
                : false;
        },
        customButtons() {
            let buttons = this.listingData.buttons ? cloneDeep(this.listingData.buttons) : [];
            if (this.canValidatePurInvoice) {
                buttons = [
                    {
                        label: this.$t.__('ocr.OcrList.check_all'),
                        event: 'verify-all',
                        primary: false,
                        disabled: !this.rows.length,
                        databot: 'purchases-purinvoices-list_verify-all',
                    },
                    ...buttons,
                ];
            }
            return buttons;
        },
    },
    created() {
        if (this.ocrLocalStorage.get()) {
            this.ocrLocalStorage.delete();
        }
        EventBus.on(
            'ocr:added',
            _.debounce(() => {
                EventBus.emit('listing:refresh');
            }, 1000),
        );
        EventBus.on(
            'ocr:completed',
            _.debounce(() => {
                EventBus.emit('listing:refresh');
            }, 1000),
        );
        EventBus.on(
            'ocr:failed',
            _.debounce(() => {
                EventBus.emit('listing:refresh');
            }, 1000),
        );
        EventBus.on('ocr:verify', this.verifySingle);
        EventBus.on('ocr:delete', this.deleteOcr);
    },
    unmounted() {
        EventBus.off('ocr:added');
        EventBus.off('ocr:completed');
        EventBus.off('ocr:failed');
        EventBus.off('ocr:verify', this.verifySingle);
        EventBus.off('ocr:delete', this.deleteOcr);
    },
    methods: {
        storeRows(hash) {
            this.hash = hash;
        },
        verifySingle({ params }) {
            goToUrl(`/purchase/incoming/verification/${params.id}`);
        },
        verifyAll() {
            this.ocrLocalStorage.set({
                rows: this.$store.state[this.hash].rows,
                multipleVerify: true,
                totalRows: this.$store.state[this.hash].rows.length,
            });
            goToUrl(`/purchase/incoming/verification/${this.ocrLocalStorage.get().rows[0].id}`);
        },
        deleteOcr({ params }) {
            Ocr.deleteOcr(params.id).then(() => {
                EventBus.emit('listing:refresh');
            });
        },
    },
};
</script>
